export default __webpack_public_path__ + "static/media/procarma-logo-white-text.2d336bee.png";